import React from 'react';
import classnames from 'classnames';
import css from './Footer.module.css';
import moment from "moment";
import settingsService from '../../../services/settingsService';
import { ReactComponent as Logo } from '../../../assets/imgs/by-lms-logo-white.svg';

const Footer = () => {

    return (
        <div data-testid="footer-component" className={`FooterPosition�${css.fixedBottom}`}>
            <div className='container' >
                <nav className='navbar navbar-light bg-black' >
                    <span className={css.copyright}>Copyright &#169; {moment().format("YYYY")}</span>
                    <span className={classnames(css.links, "navbar-text")} >
                        <a className='text-white' data-testid="terms-of-use" href={settingsService.settings.termsOfUse} target="_blank" rel="noreferrer">Terms of Use</a>
                        <span className={css.pipe}></span>
                        <a className='text-white' data-testid="privacy-policy" href={settingsService.settings.privacyPolicy} target="_blank" rel="noreferrer">Privacy Policy</a>
                    </span>

                    <span>&nbsp;</span>
                    <span>&nbsp;</span>
                    <span>&nbsp;</span>
                    <span>&nbsp;</span>
                    <span>&nbsp;</span>
                    <span>&nbsp;</span>
                    <span>&nbsp;</span>
                    <span>&nbsp;</span>
                    <span>&nbsp;</span>

                    <div className="d-flex">
                        <Logo id="logo" data-testid="logo" className={css.logo} />
                    </div>
                </nav>
            </div>
        </div>
    );
}


export default Footer;